export default __webpack_public_path__ + "6158b9f9abcb114164ae8937d0ca6a3b.svg";